export default {
  beforeForm: ({ form }) => {
    form.includes_manual_launch_and_transfer = form.includes_manual_launch_and_transfer ? 'yes' : 'no';
    form.is_only_selected_banks = form.is_only_selected_banks ? 'yes' : 'no';
  },
};
